<div class="asset-list-container">
    <h1>Assets Overview</h1>
    <div *ngIf="loading == true">
        <h2>Loading data...</h2>
    </div>
    <div *ngIf="loading == false" fxLayout="column nowrap">
        <div>
            <h3>Assets ({{assets.length}})</h3>
        </div>
        <div *ngIf="assets.length == 0">
            <h5>No asset records found!</h5>
        </div>
        <div fxLayout="row nowrap">
            <div *ngFor="let asset of assets">
                <mat-card class="asset-card">
                    <mat-card-header>
                        <mat-card-title>{{asset.Name}}</mat-card-title>
                        <mat-card-subtitle>{{asset.Description}}</mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                        <div>
                            <div class="asset-card-data-item">
                                <div>{{asset.PurchasePrice.Amount | currency}}</div>
                                <div><small>Purchase at {{asset.PurchasePrice.At | date : 'mediumDate'}}</small></div>
                            </div>
                            <div class="asset-card-data-item">
                                <div>{{asset.Valuations.length > 0 ? (asset.Valuations[asset.Valuations.length -
                                    1].Amount |
                                    currency) : ('--')}}</div>
                                <div><small>Latest Valuation {{asset.Valuations.length > 0 ? ((' at ') +
                                        (asset.Valuations[asset.Valuations.length - 1].At | date : 'mediumDate') ) :
                                        ('')}}</small></div>
                            </div>
                            <div class="asset-card-data-item">
                                <div>{{asset.Deposit.Amount | currency}}</div>
                                <div><small>Deposit at {{asset.Deposit.At | date : 'mediumDate'}}</small></div>
                            </div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions>
                        <button type="button" mat-button color="primary" [routerLink]="['../assets', asset.Id]">
                            <mat-icon>folder_open</mat-icon>Open
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
        <div>
            <h3>Exploration ({{exploratoryAssets.length}})</h3>
        </div>
        <div *ngIf="exploratoryAssets.length == 0">
            <h5>No exploratory asset records found!</h5>
        </div>
        <div fxLayout="row nowrap">
            <div *ngFor="let expAsset of exploratoryAssets">
                <mat-card class="asset-card">
                    <mat-card-header>
                        <mat-card-title>{{expAsset.Name}}</mat-card-title>
                        <mat-card-subtitle>{{expAsset.Description}}</mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                        <div>
                            <div class="asset-card-data-item">
                                <div>{{expAsset.PurchasePrice.Amount | currency}}</div>
                                <div><small>Purchase at {{expAsset.PurchasePrice.At | date : 'mediumDate'}}</small>
                                </div>
                            </div>
                            <div class="asset-card-data-item">
                                <div>{{expAsset.Valuations.length > 0 ? (expAsset.Valuations[expAsset.Valuations.length
                                    -
                                    1].Amount |
                                    currency) : ('--')}}</div>
                                <div><small>Latest Valuation {{expAsset.Valuations.length > 0 ? ((' at ') +
                                        (expAsset.Valuations[expAsset.Valuations.length - 1].At | date : 'mediumDate') )
                                        :
                                        ('')}}</small></div>
                            </div>
                            <div class="asset-card-data-item">
                                <div>{{expAsset.Deposit.Amount | currency}}</div>
                                <div><small>Deposit at {{expAsset.Deposit.At | date : 'mediumDate'}}</small></div>
                            </div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions>
                        <button type="button" mat-button color="primary" [routerLink]="['../assets', expAsset.Id]">
                            <mat-icon>folder_open</mat-icon>Open
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
    </div>
    <button mat-fab color="primary" aria-label="Add new asset" class="asset-fab--absolute"
        [routerLink]="['../assets/create']">
        <mat-icon>add</mat-icon>
    </button>
</div>